import Dashboard from './views/DashboardView.vue'
import ConfirmPasswordReset from '../account/views/ConfirmPasswordRecovery'

export default [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/password_recovery/:token',
    name: 'confirmPasswordReset',
    component: ConfirmPasswordReset
  }
]
